export const focusMap = new Map<string, HTMLElement>()
